"use client";

import Image from "next/image";
import { BlockProps } from "../BlocksManager/registry";

const colorOrder = [
  {
    bubble: "bg-yellow text-white",
    border: "border-b-4 border-white hover:border-yellow",
  },
  {
    bubble: "bg-orange text-white",
    border: "border-b-4 border-white hover:border-orange",
  },
  {
    bubble: "bg-green text-white",
    border: "border-b-4 border-white hover:border-green",
  },
];

export default function EtapesCommande({ data }: BlockProps) {
  if (!data) return null;

  const steps = data.etapes || [];

  return (
    <section className="relative overflow-hidden bg-violet-light py-14 md:py-20">
      {/* Décors latéraux */}
      <div className="pointer-events-none absolute inset-y-0 left-0 hidden w-full xl:block">
        <Image
          src="/img-left.png"
          alt="Décor pâtes gauche"
          fill
          className="object-contain object-left"
          priority
        />
      </div>

      <div className="pointer-events-none absolute inset-y-0 right-0 hidden w-full xl:block">
        <Image
          src="/img-right.png"
          alt="Décor pâtes droite"
          fill
          className="object-contain object-right"
          priority
        />
      </div>

      <div className="container relative z-10">
        <div className="mx-auto max-w-[1100px] text-center">
          <h2 className="font-literata text-[28px] font-bold leading-[1.28] text-black sm:text-[42px] lg:text-[56px]">
            {data.titre}
          </h2>
        </div>

        <div className="mx-auto mt-20 grid max-w-[1100px] gap-8 md:grid-cols-2 xl:grid-cols-3">
          {steps.map((step: any, index: number) => {
            const icon = step?.icone?.url;
            const styles = colorOrder[index % colorOrder.length];

            return (
              <article
                key={step.id}
                className={`relative rounded-[46px] bg-white px-6 pb-8 pt-12 text-center shadow-[0_12px_35px_rgba(0,0,0,0.04)] ${styles.border}`}
              >
                {/* Pastille numéro */}
                <div
                  className={`absolute left-1/2 top-0 flex h-[68px] w-[68px] -translate-x-1/2 -translate-y-1/2 items-center justify-center rounded-full text-[32px] font-bold ${styles.bubble}`}
                >
                  {index + 1}
                </div>

                {/* Icône */}
                <div className="flex justify-center">
                  <div className="relative h-[110px] w-[110px]">
                    {icon && (
                      <Image
                        src={icon}
                        fill
                        className="object-contain"
                        alt={step?.icone?.alternativeText || step.label || "Icône étape"}
                      />
                    )}
                  </div>
                </div>

                {/* Titre */}
                <h3 className="mt-5 font-body text-[26px] font-bold leading-[1.15] text-black md:text-[30px]">
                  {step.label}
                </h3>

                {/* Description */}
                <p className="mx-auto mt-4 max-w-[290px] text-[17px] leading-[1.45] text-black/80 md:text-[18px]">
                  {step.description}
                </p>
              </article>
            );
          })}
        </div>
      </div>
    </section>
  );
}